const ContactFormSuccess = () => (
  <div className="c7-subscribe-message">
    <p>
      Thank you for contacting us.
      <br /> We will reply to your inquiry within two business days.
    </p>
  </div>
);

export default ContactFormSuccess;
